<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name(:class="{ 'non-active-font': !active }") {{ keyName }}
      span.validation-label(v-if="required == true") 必須
      slot(name="question")
      
    slot(name="description")
    .register-value
      label
        input(
          v-model="_value"
          :name="name"
          type="checkbox"
          v-validate="validationRules"
          :data-vv-as="(validationKeyName) ? validationKeyName : keyName"
          :class="{ noinput: (required == true && !_value) }"
          :disabled="disabled")
        span.text(:class="[{ 'active': active }, { 'non-active': !active }, { 'non-active-font': !active }, { 'disable': disabled }]" @click="onClick") {{ label }}

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

    slot(name="default")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * 現在は使用しないが、将来を考え用意している
 *
 * - チェックボックスをサポートする
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component({})
export default class FormCheck extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** チェックボックスのラベル */
  @Prop({ required: true, type: String })
  label!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  private validationKeyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private styles!: any;

  /** 活性化/非活性化 */
  @Prop({
    default: () => {
      return true;
    }
  })
  public active!: boolean;

  /** 活性/非活性 */
  @Prop()
  disabled!: boolean;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  /** チェックボックスのクリックイベント */
  public onClick(): void {
    this.$emit("onClick");
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.text {
  margin: 0 !important;
}

// 画像でセレクトボックスを表現するので、input要素自体は非表示にする
input[type="checkbox"] {
  display: none;

  // input要素の代わりに画像つきのspanにする
  // 選択しているか否かで画像を切り替える
  // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
  & + span {
    // チェックボックス画像が全て表示されるように高さを指定する
    height: 46px;
    // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
    padding: 6px 0 0 40px;
    background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
  }
  &:checked + span {
    background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
    // チェックボックス画像のサイズを指定
    // 正方形なので要素の高さと同じになる
    background-size: 32px 32px;
  }
}
.active {
  cursor: pointer;
}
.non-active,
.disable {
  cursor: not-allowed;
}
.non-active-font {
  color: $form-border-color;
}
</style>
